<template>
  <div class="cover-content table-wrapper">
      <Form ref="formInline" :model="formInline" inline class="form-list" :label-width="100" label-position="right">
            <div class="search-right-wrapper">
                <Button :loading="eLoading" type="primary" style="float:left;" @click="handleExport" icon="ios-exit-outline">导出</Button>
                <FormItem label="日期:" style="width:286px;text-align:left;">
                  <DatePicker v-model='formInline.起始日期' type="daterange" placeholder="请选择起始日期" @on-change='handleChangeDate' split-panels></DatePicker>
                </FormItem>
                <FormItem label="数据来源:" style="width:286px;text-align:left;">
                  <Select v-model="formInline.dataSource" placeholder="请选择数据来源">
                    <Option v-for="(item, index) in selList" :value="item" :key="`sel-it-` + index">{{ item }}</Option>
                  </Select>
                </FormItem>
                <Button style="margin-left: 15px;float:right;" @click="handleReset">重置</Button>
                <Button style="float:right;" type="primary" @click="handleQuery">搜索</Button>
            </div>
      </Form>
    <!-- <div style="margin-bottom: 24px;">
      <Button type="primary" @click="handleExport">导出</Button>
    </div> -->
    <div class='cover-table'>
      <Table style="width: 100%;" max-height='520' :loading="loading" border :columns="tableColumns" :data="tableData" highlight-row>
        <template slot-scope="{ row, index }" slot="action">
          <span class="pointer"  @click="handleDeal('dataFromDetail',row.areaCode)">详情</span>
        </template>
      </Table>
      <Page class='page' :total="totalCount" :page-size="pageSize" :current="page" @on-change="changePage" @on-page-size-change="pageSizeChange" show-elevator show-sizer show-total transfer>
      </Page>
    </div>
  </div>
</template>
<style scoped>

</style>
<script>
    import { mapState } from 'vuex';
    import tableMixin from '@/components/tableMixin';

    export default {
        mixins: [tableMixin],
        data(){
          return {
              eLoading: false,
              formInline:{
                起始日期: '',
                areaCode: localStorage.getItem('tenantAreaCode'),
                current: 1,
                endDate: "",
                dataSource: "",// 数据对接标准
                size: 10,
                startDate: ""
              },
              selList: [],
              tableColumns:[
                  { title: '序号', type: 'index', width: 70, fixed: 'left', align: 'center' },
                  { title: '数据来源', key: 'dataSource', minWidth: 100 },
                  { title: '数据末次推送时间', key: 'pushTime', minWidth: 180 },
                  { title: '推送次数', key: 'pushNum', minWidth: 100, align: 'right' },
                  { title: '数据总条数', key: 'totalNum', minWidth: 140, align: 'right' },
                  { title: '操作', slot: 'action', fixed: 'right', align: 'center', width: 100 }
              ],
              tableData: []
          }
        },
        computed:{
          ...mapState(['navList','area','citys'])
        },
        created(){
          this.axios({
            method: 'post',
            url:'/dataSource/sx/dropDown',
            data: {
                areaCode: localStorage.getItem('tenantAreaCode')
            }
          }).then((res) => {
            this.selList = res.data.data || []
          })
        },
        mounted(){

        },
        watch: {

        },
        methods: {
          // handleQuery() {
          //   this.formInline.current = 1
          //   this.getTableData()
          // },
          handleChangeDate(val) {
            this.formInline.startDate = val[0]
            this.formInline.endDate = val[1]
          },
          handleReset() {
            this.page = 1
            this.pageSize = 10;
            this.formInline = {
              起始日期: '',
              areaCode: "",
              current: 1,
              endDate: "",
              dataSource: "",// 数据对接标准
              // size: 10,
              startDate: ""
            }
            this.getTableData()
          },
          //分页切换
        changePage(value) {
            this.page = value
            this.formInline.current = value;
            this.getTableData()
          },
          //导出
          handleExport(){
            const { areaCode, current, endDate, dataSource, size, startDate } = this.formInline
              this.eLoading = true;
            this.axios({
              method: 'post',
              url:'/dataSource/sx/export',
              responseType:'arraybuffer',
              data: {
                areaCode, current:this.page, endDate, dataSource, size:this.pageSize, startDate
              }
            }).then( (response)=> {
                this.eLoading = false;
              this.common.download(response, '数据来源.xls','application/vnd.ms-excel');
            }).catch(() => {
                this.eLoading = false;
            });
          },
          /*处理操作*/
          handleDeal(name,areaCode){
            this.$router.push({
              name: name,
              query: {
                areaCode
              }
            })
          },
          /*获取表格数据*/
          getTableData(){
              const { areaCode, current, endDate, dataSource,  startDate } = this.formInline
              this.loading=true;
              this.axios({
                  method: 'post',
                  url: '/dataSource/sx/list',
                  data: {
                    areaCode, current:this.page, endDate, dataSource, size:this.pageSize, startDate
                  }
              }).then( (response)=> {
                  this.loading=false;
                  if (response.data.success){
                      this.totalCount = response.data.data.total;
                      this.tableData = response.data.data.records;
                  }
              }).catch( ()=> {
                  this.loading=false;
              });
          },
      }
    };
</script>
